export { default } from "./TextAlignmentPicker";
